import React, { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import './main.scss';
import axios from 'axios';
import { decode_token_acls, getCompanyId, getUser, removeUserSession, getToken } from '../../Utils/Common';
import { useComponentContext } from "../../contexts/component-context";
import { usePermissionContext } from "../../contexts/permission-context";
import Layout from "../Layout/Layout";
import io from 'socket.io-client';
import config from '../../app.config';
import jwt_decode from "jwt-decode";
import sharePermission from "../../Utils/sharePermission";
import { useIdleTimer, workerTimers } from 'react-idle-timer'
//let flag = false;
let expiry = 0;
let socket = null;
let sessionExpiryIntervalId;

let extendedTimeOut;
function Main(props) {
    //console.log("entering Main");
    // const [isLoading, setLoading] = useState(true); // Loading state
    const { selectedComponent } = useComponentContext();
    const { setPermissions } = usePermissionContext();
    let navigate = useNavigate();
    const [state, setState] = useState('Active');
    const [isDialogVisible, setDialogState] = useState(false);

    const onIdle = () => {
        setState('Idle');
        //if (!sessionExpiryIntervalId && !isDialogVisible) {
        if (!isDialogVisible) {
            // console.log("session expiry called :" + new Date());
            //sessionExpiryIntervalId = setInterval(showSessionExpiryDialog, expiry);
            showSessionExpiryDialog();
        }
    }

    const onActive = () => {
        setState('Active');
        //clearAllTimeout();
        clearInterval(sessionExpiryIntervalId);
        sessionExpiryIntervalId = null;
    }
    /* detects application idle time , if user is idle for 4 mins session expiry dialog will be displayed 
       mousemove,keydown,wheel,mousedown,visibilitychange,MSPointerDown,MSPointerMove
    */
    const { getRemainingTime } = useIdleTimer({
        timers: workerTimers,
        onIdle,
        onActive,
        timeout: config.config.idle_time_interval, // 4 mins to detect application idle time
        throttle: 500
    })

    socket = io({ path: '/insws' },
        {
            reconnection: true,
            reconnectionDelay: config.config.webServerSocket.reconnectionDelay,
            reconnectionDelayMax: config.config.webServerSocket.reconnectionDelayMax,
            reconnectionAttempts: Infinity,
            //our site options
            //transports: ["polling", "websocket"],
            transports: ["websocket"],
            rejectUnauthorized: config.config.redisSSL && config.config.kafkaSSL && true || false,
            secure: config.config.redisSSL && config.config.kafkaSSL && true || false,
            forceNew: false,
            timeout: config.config.webServerSocket.pingTimeout,
            autoConnect: false,
            upgrade: true
        }
    );

    expiry = config.config.sessionInterval - config.config.expiry_reminder_interval;

    // let z = parseInt(sessionStorage.getItem('sessionExpiry'));

    // if (z) {
    //     expiry = z - 120000;
    // }
    // else {
    //     //console.log('expiry is NULL');
    //     expiry = config.config.sessionInterval - 120000;
    // }

    const showSessionExpiryDialog = () => {
        let dialog = document.getElementById('dialog');
        dialog && document.getElementById('dialog').show();
        setDialogState(true);
        // start timer for logging user out forcefully, if user doesnt respond to notification at all
        extendedTimeOut = setTimeout(logOutUser, config.config.expiry_reminder_interval); //if user doesnt respond, just logout after 1 min
    };

    const handleExtendSession = () => {
        console.log('Extending session now..');
        document.getElementById('dialog').close();
        setDialogState(false);
        extendSession(sessionStorage.getItem('userId'), sessionStorage.getItem('companyId'));
        refreshToken(sessionStorage.getItem('userId'), sessionStorage.getItem('companyId'), sessionStorage.getItem('auth_token'));
        // clearTimeout(extendedTimeOut);
        clearAllTimeout()
            .then((response) => {
                //console.log('response after timeput clear:', response);
                // setInterval(showSessionExpiryDialog, expiry); // set Timeout for 13 mins again after extending session expiry
                setInterval(refreshTokenData, config.config.refreshTokenInterval); //refresh token every 5mins
            })
            .catch((err) => {
                console.log('error clearing timeout:', err);
                // setInterval(showSessionExpiryDialog, expiry); // set Timeout for 13 mins again after extending session expiry
                //setInterval(refreshTokenData, config.config.refreshTokenInterval);
            });
    }

    const clearAllTimeout = () => {
        console.log('clearing timeouts..');
        return new Promise((resolve, reject) => {
            let i = 0;
            let highestId = window.setTimeout(() => {
                for (i = highestId; i >= 0; i--) {
                    window.clearTimeout(i);
                }
                if (i === -1) {
                    highestId = window.setInterval(() => {
                        for (i = highestId; i >= 0; i--) {
                            window.clearInterval(i);
                        }
                        if (i === -1) {
                            //return resolve(true);
                            resolve(true);
                        }
                        else
                            //return reject(false);
                            reject(false);
                    }, 0);
                }
                else
                    //return reject(false);
                    reject(false);
            }, 0);


        });

    }

    const clearAllIntervals = () => {
        console.log('clearing setintervals..');
        return new Promise((resolve, reject) => {
            let i = 0;
            let highestId = window.setInterval(() => {
                for (i = highestId; i >= 0; i--) {
                    window.clearInterval(i);
                }
                if (i === -1) {
                    //return resolve(true);
                    resolve(true);
                }
                else
                    //return reject(false);
                    reject(false);
            }, 0);
        });
    }

    const handleCancel = () => {
        console.log('cancelled..');
        document.getElementById('dialog').close();
        setDialogState(false);
        //setSessionExpiryDialog(false);
        //setTimeout(logOutUser, 60000); // if not extending, log out user in 30secs. remaining.
        logOutUser();
    }

    const logOutUser = () => {
        socket.close();
        socket.emit("log_out_user: logging out user now...closed websocket");
        console.log('logging out user now...closed websocket');
        navigate('/');
        handleLogout();
        clearAllTimeout();
        // window.localStorage.clear();
        // window.sessionStorage.clear();
    }
    const handleLogout = async () => {
        await removeUserSession();
    }
    const [message, setMessage] = useState(sharePermission.initialState);

    useLayoutEffect(() => {
        sharePermission.subscribe(setMessage);
    }, []);

    useLayoutEffect(() => {
        let token = sessionStorage.getItem('auth_token') || false;
        let decoded = jwt_decode(token);
        if (decoded) {
            let data = JSON.parse(decoded.insightUser);
            let acls = data?.userAuthInfo?.acls;
            if (acls) {
                setPermissions(data.userAuthInfo.acls);
                sharePermission.sendMessage(JSON.stringify(data.userAuthInfo.acls));
            } else {
                console.log("No acls defined in auth token");
            }
        } else {
            console.log("Failed to decode auth token");
        }
    }, []);

    useEffect(() => {
        // console.log("useeffect called..................." + new Date());
        //state === 'Idle' && setInterval(showSessionExpiryDialog, expiry); // show reminder every 13 minutes = 780K milliseconds
        setInterval(refreshTokenData, config.config.refreshTokenInterval); //refresh token every 5mins

        console.log('connected to websocket server..')
        socket.emit("hello_server", { uid: getUser(), cid: getCompanyId(), loginInfo: getCurrentUserDetails() });

        socket.on("hello_user", data => {
            console.log('greetings from server:', data);
        });

        socket.on('log_out_user', () => {
            //alert('Your session was removed from server, logging you off !!');
            document.getElementById('dialogLogout').showModal();
            //setSessionRemoveDialog(true);
            console.log('session was killed on server, logging you off now !');
            //logOutUser();
            setTimeout(logOutUser, 2000);
            socket.close();
            console.log('socket closed..');
        });

    }, []);


    const refreshTokenData = () => {
        if (sessionStorage.getItem('auth_token')) {
            refreshToken(sessionStorage.getItem('userId'), sessionStorage.getItem('companyId'), sessionStorage.getItem('auth_token'));
            // for now just blindly update permissions all the time
            let token = getToken();
            if (token) {
                let acls = decode_token_acls(token);
                setPermissions(acls);
            }

        }
        else {
            console.log('refreshTokenData else .... ' + new Date());
            clearTimeout();
            // clearAllTimeout();
            clearAllIntervals();
        }
    }

    const getCurrentUserDetails = () => {
        return {
            'user-id': getUser(),
            'user-agent': navigator.userAgent,
            'time-stamp': new Date().toUTCString(),
            'location': Intl.DateTimeFormat().resolvedOptions().timeZone
        }
    }


    return (
        <div className={state === 'Idle' ? 'idleState' : 'activeState'}>
            <Layout>{selectedComponent}
                {/* <p>Current State: {state}</p> */}
            </Layout>
            <dialog id="dialog" className='expiryDialog'>
                <div>
                    <p>Your session will expire in 1 minute, do you want to extend it now?</p>
                    <button onClick={handleExtendSession}>Yes</button>
                    <button onClick={handleCancel}>No</button>
                </div>
            </dialog>
            <dialog id="dialogLogout" className='sessionDialog'>
                <div>
                    <p>Your session was removed from server, logging you off !!</p>
                </div>
            </dialog>
        </div>

    );
}

export const closeSocket = () => {
    if (socket.connected) {
        socket.emit('close_connection', { uid: getUser() });
        socket.close();
        console.log('closed websocket..');
    }
}
/* UNUSED
export const setFlag = (value) => {
    flag = value;
}
*/


const refreshToken = (userId, companyId, token) => {
    try {
        axios({ method: "post", url: '/api/auth/token/refresh', headers: { 'insightUserId': userId, 'companyId': companyId, 'Authorization': token } })
            .then(response => {
                // console.log('got refresh session token ' + new Date());
                if (!response.data.startsWith("Bearer"))
                    response.data = "Bearer " + response.data;
                sessionStorage.setItem('auth_token', response.data);
            }).catch(error => {
                console.log('error in session refresh api call:', error);
            });
    }
    catch (e) {
        console.log(e);
    }
}

const extendSession = (userId, companyId) => {
    try {
        axios({ method: "post", url: '/session/ttl', data: { 'userId': userId, 'companyId': companyId, 'source': 'main_page' }, headers: { "Content-Type": "application/json" } })
            .then(response => {
                console.log('got refresh session update :', response);
            }).catch(error => {
                console.log('error in session refresh api call:', error);
            });
    }
    catch (e) {
        console.log(e);
    }
}

export default Main;
